let currentToken = null;

const authAPI = {
  setAuthToken(token) {
    currentToken = token || null;
    try {
      if (token) {
        localStorage.setItem('token', token);
      } else {
        localStorage.removeItem('token');
      }
    } catch (_) {}
  },
  removeAuthToken() {
    currentToken = null;
    try {
      localStorage.removeItem('token');
    } catch (_) {}
  },
  getAuthToken() {
    if (!currentToken) {
      try {
        currentToken = localStorage.getItem('token');
      } catch (_) {}
    }
    return currentToken;
  },
};

export default authAPI;
